import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, Col, Container, Form, FormFeedback, Input, Row, Label, Card, CardBody, CardText } from 'reactstrap'
import { useFormik } from "formik";
import * as Yup from "yup";
import 'flatpickr/dist/themes/material_green.css';
import {  isEmpty } from 'lodash';
import { addInquiryRemarks, getInquiryInfomation } from 'helpers/UAM/inquiry.helper';
import moment from 'moment';
import ToastDialog from 'common/ToastDialog';
import { formatNumberWithCommas } from '../../common/utility'
import { SystemConfigurationContext } from 'context/systemConfigContext';


const ViewInquiry = () => {
    const navigate = useNavigate()
    let { subInquiryNumber } = useParams();


    if (!isEmpty(subInquiryNumber)) {
        subInquiryNumber = atob(subInquiryNumber)
    }


    const [isBtnLoading, setIsBtnLoading] = useState(false)
    const [toastInfo, setToastInfo] = useState({ showToast: false });
    const [inquiryInfo, setInquiryInfo] = useState({});


    const { inputMax } = useContext(SystemConfigurationContext)



    const handleFormSubmit = async (values) => {
        setIsBtnLoading(true)
        const bodyData = {
            id: inquiryInfo.id,
            remarks: values.remarks,
            remarksBy: 'dealer'
        }
        const res = await addInquiryRemarks(bodyData);
        if (res.status) {
            formik.resetForm()
            getInquiryInfo()
        } else {
            setToastInfo({ message: res.message, showToast: true, role: "error" });
        }
        setIsBtnLoading(false)
    }





    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            remarks: '',
        },
        validationSchema: Yup.object({
            remarks: Yup.string().required('Remarks is required'),
        }),
        onSubmit: async (values) => {
            handleFormSubmit(values)
        },
    });



    const setInquiryData = (data) => {
        let file = ''
        const productImages = !isEmpty(data.productImages) ? JSON.parse(data.productImages) : []
        file = !isEmpty(productImages) ? productImages[0] : ''
        const inquiryData = {
            id: data.id,
            productStatus: data.productStatus,
            remarks: data.remarks,
            productDescription: data.productDescription,
            quantity: data.quantity,
            price: data.price,
            deliveryDate: data.deliveryDate,
            dealerName: data.dealer.entityName,
            inquiryNumber: data.inquiryNumber,
            file: file,
        }
        setInquiryInfo(inquiryData)
    }



    async function getInquiryInfo() {
        const res = await getInquiryInfomation({ subInquiryNumber: subInquiryNumber })


        if (res.status) {
            setInquiryData(res.data)
        } else {
            setToastInfo({ message: res.message, showToast: true, role: "error" });
        }
    }


    useEffect(() => {
        getInquiryInfo()
    }, [subInquiryNumber])



    const handleFilePreview = (url) => {
        fetch(url)
            .then(response => response.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = url.split('/').pop();
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            })
            .catch(error => {
                setToastInfo({ message: error.message, showToast: true, role: "error" });
            });
    }



    const PreviewFile = ({ file }) => {


        const previewFile = file
        const previewUrl = `${process.env.REACT_APP_IMAGE_URL}/${previewFile}`
        return (
            <div className="d-flex align-items-center">
                {previewFile ? (
                    <p className="text-success text-xl" onClick={() => handleFilePreview(previewUrl)} style={{
                        cursor: "pointer",
                    }}>
                        <i color='#21a946' className="bx bx-download"></i>
                    </p>
                ) : (
                    <span className="preview-message">-</span>
                )}
            </div>
        );
    }


    const ProductDescription = ({ desc = "" }) => {
        let descLength = desc.length


        const [showReadMore, setShowReadMore] = useState(descLength > 150);


        let descToShow = desc.substring(0, 150);
        let descToHide = desc.substring(150, descLength);


        const handleReadMore = () => {
            setShowReadMore(false);
        }


        const handleReadLess = () => {
            setShowReadMore(true);
        }



        return (
            <p>
                {showReadMore ? descToShow : descToShow + descToHide} {" "}
                {showReadMore && (
                    <span style={{ cursor: 'pointer' }} className="read-more-link  text-decoration-underline" onClick={handleReadMore}>
                        ...Read More
                    </span>
                )}
                {descLength > 150 && (!showReadMore) && (
                    <span style={{ cursor: 'pointer' }} className="read-more-link  text-decoration-underline" onClick={handleReadLess}>
                        Read Less
                    </span>
                )}
            </p>
        )
    }



    const bgStyle = {
        background: '#fff',
        boxShadow: '0 1px 4px #344fa0',
        borderRadius: '10px',
        marginTop: '10px'
    }


    const bgStyleReply = {
        background: '#fff',
        boxShadow: '0 1px 4px #ccc',
        borderRadius: '10px',
        marginTop: '10px'
    }


    const handleCancel = () => {
        navigate(-1)
    }
    // check if any remarks added by user
    const lastInquiryRemarks = !isEmpty(inquiryInfo?.remarks) ? inquiryInfo?.remarks[inquiryInfo?.remarks.length - 1] : {}



    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className='page-title-box pb-2 d-flex gap-3 justify-content-between align-items-center w-100 mb-1'>

                        <h4 className='mb-0'>View Inquiry</h4>

                        <button
                            className="btn btn-outline-secondary ms-2"
                            type="button"
                            onClick={handleCancel}
                        >
                            Back
                        </button>
                    </div>
                    <Row className='g-2 d-flex align-items-start justify-content-start'>
                        <Col sm={12} md={12} lg={12} xl={12} className=' card'>
                            <div className='card-body p-4'>
                                <Row>
                                    <div className="col-6 col-md-3 mb-3">
                                        <Label className="form-label label-styling">Inquiry Number</Label>
                                        <p className="">INQ-{inquiryInfo.inquiryNumber}</p>
                                    </div>
                                    <div className="col-6 col-md-3 mb-3">
                                        <Label className="form-label label-styling">Sub Inquiry Number</Label>
                                        <p className="">SUBINQ-{subInquiryNumber}</p>
                                    </div>
                                    <div className="col-6 col-md-3 mb-3">
                                        <Label className="form-label label-styling">Dealer Name</Label>
                                        <p className="">{inquiryInfo.dealerName}</p>
                                    </div>
                                    <div className="col-6 col-md-3 mb-3">
                                        <Label className="form-label label-styling">Expected Delivery Date</Label>
                                        <p className="">{!isEmpty(inquiryInfo.deliveryDate) ? moment(inquiryInfo.deliveryDate).format('MMM DD, YYYY') : ''}</p>
                                    </div>
                                    <div className="col-6 col-md-3 mb-3">
                                        <Label className="form-label label-styling">Expected Quantity</Label>
                                        <p className="">{inquiryInfo.quantity}</p>
                                    </div>
                                    <div className="col-6 col-md-3 mb-3">
                                        <Label className="form-label label-styling">Expected Price Per Unit</Label>
                                        <p className="">{formatNumberWithCommas(+inquiryInfo.price)}</p>
                                    </div>
                                    <div className="col-6 col-md-3 mb-3">
                                        <Label className="form-label label-styling">Download attachment</Label>
                                        <PreviewFile file={inquiryInfo.file} />
                                    </div>
                                    <div className="col-6 col-md-3 mb-3">
                                        <Label className="form-label label-styling">Product Description</Label>
                                        <ProductDescription desc={inquiryInfo.productDescription} />
                                    </div>
                                </Row>
                            </div>
                        </Col>


                        <Col sm={12} md={6} lg={6} xl={6} className='card '>
                            <Row className="timeline card-body pb-0 px-1">
                                {(lastInquiryRemarks.addedBy == 'user' || inquiryInfo.remarks?.length > 0) && inquiryInfo.productStatus == 'pending' && <Form className='px-1 mt-2' onSubmit={formik.handleSubmit}>
                                    <div style={{ width: '100%', position: 'relative' }}>
                                        <div style={{ marginBottom: '20px' }}>
                                            <Input
                                                maxLength={inputMax}
                                                value={formik.values.remarks}
                                                type='textarea'
                                                name='remarks'
                                                id='remarks'
                                                placeholder='Enter your query/comments'
                                                onChange={formik.handleChange}
                                                style={{
                                                    minHeight: '80px',
                                                    borderRadius: '8px',
                                                    padding: '10px',
                                                    resize: 'none',
                                                    width: '100%',
                                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                                }}
                                                className={`${formik.touched.remarks && formik.errors.remarks ? 'is-invalid' : ''}`}
                                            />
                                        </div>
                                        <div style={{ position: 'absolute', bottom: '8px', right: '10px' }}>
                                            <Button
                                                disabled={isBtnLoading}
                                                type='submit'
                                                color='success'
                                                style={{ padding: '8px', borderRadius: '50%', width: '40px', height: '40px' }}
                                            >
                                                {isBtnLoading && <span className='spinner-border spinner-border-sm mr-1'></span>}
                                                <i className='bx bx-send'></i>
                                            </Button>


                                        </div>
                                        {formik.touched.remarks && formik.errors.remarks ? (
                                            <FormFeedback className='d-block text-danger' style={{ position: 'absolute', bottom: '-20px', left: '10px' }}>
                                                {formik.errors.remarks}
                                            </FormFeedback>
                                        ) : null}
                                    </div>


                                </Form>}
                                <div style={{
                                    height: inquiryInfo.productStatus == 'pending' ? '350px' : 'auto',
                                    overflowY: 'scroll',
                                }}
                                    className='mt-3'
                                >
                                    {!isEmpty(inquiryInfo?.remarks) ? inquiryInfo?.remarks.slice(0).reverse().map((item, index) => {
                                        return (
                                            <div className="msger-chat" key={index}>
                                                {item.addedBy !== 'dealer' ? 
                                            <div className="msg left-msg">
                                         
                                        
                                              <div className="msg-bubble">
                                                <div className="msg-info">
                                                  <div className="msg-info-name">{item.user}</div>
                                                  <div className="msg-info-time"><span>{ moment(item.createdAt).format("MMM DD YYYY, HH:mm A")}</span></div>
                                                </div>
                                                <div className="msg-text">
                                                {item.remarks}
                                                </div>
                                              </div>
                                            </div>
                                        :
                                            <div className="msg right-msg">
                                             
                                        
                                              <div className="msg-bubble">
                                                <div className="msg-info">
                                                  <div className="msg-info-name">{item.user}</div>
                                                  <div className="msg-info-time d-flex flex-column">
                                                    {/* <span>{ moment(item.createdAt).format("MMM DD, YYYY")}</span><span>{ moment(item.createdAt).format("HH:mm A")}</span></div> */}
                                                    <span>{ moment(item.createdAt).format("MMM DD YYYY, HH:mm A")}</span></div>
                                                </div>
                                        
                                                <div className="msg-text">
                                                {item.remarks}
                                                </div>
                                              </div>
                                            </div>
                                            }
                                          </div>
                                        )
                                    }) :
                                        (
                                            <div className='d-flex align-items-center justify-content-center'>
                                                <p className='mb-0'>No communication found</p>
                                            </div>
                                        )
                                    }
                                </div>
                            </Row>
                        </Col>
                    </Row>


                </Container>
            </div>
            <ToastDialog
                message={toastInfo.message || ""}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            ></ToastDialog>

        </React.Fragment>
    )
}


export default ViewInquiry